module.exports = __webpack_public_path__ + "assets/dbb6ef4afd91c9f9ffbf146160950b11.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/taylorice/Documents/Roc2/engine/public-src/spingames/panel/sounds/buttons/lobby.mp3
 ** module id = 25
 ** module chunks = 0
 **/